import React from "react";

export default function Spinner() {
  return (
    <div className="flex justify-center items-center py-0 my-8">
      <div className="w-8 h-8 border-4 border-white-500 border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
}
